/**
 * Drops authorized ids that are no longer in the waiting queue.
 * Must not clear the whole list on queue growth — authorizers report once per mount.
 *
 * @param {string[]} authorizedCallIds
 * @param {string} waitingCallIdsKey comma-joined call ids currently waiting
 * @returns {string[]}
 */
export default function pruneAuthorizedWaitingCallIds(authorizedCallIds, waitingCallIdsKey) {
  const validIds = waitingCallIdsKey.length > 0
    ? waitingCallIdsKey.split(',')
    : [];
  return (authorizedCallIds ?? []).filter((id) => validIds.includes(id));
}
